import React from 'react';
import secB from '../../assets/images/cardImages/policies.jpg';
import bg from '../../assets/images/background.svg'
import Counter from '../ReusableComponents/counter';


//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import TrackChangesRoundedIcon from '@mui/icons-material/TrackChangesRounded';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CardMembershipRoundedIcon from '@mui/icons-material/CardMembershipRounded';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';

const counterData = [
    {
        "num": 0,
        "label": "Signatory",
        "icon": ReceiptLongIcon,
        "prefix": "UN Global Compact",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 0,
        "label": "Only Auto company globally disclosing Core & Expanded metrics as per WEF's Stakeholder Capitalism Metrics",
        "icon": MilitaryTechIcon,
        "prefix": "World Economic Forum",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 0,
        "label": "DJSI leader status in the Automobiles Industry with a score of 83",
        "icon": MilitaryTechIcon,
        "prefix": "Dow Jones Sustainability Index",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 0,
        "label": "Environmental Management System certified",
        "icon": CardMembershipRoundedIcon,
        "prefix": "ISO 14001",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 0,
        "label": "OHS management system certified",
        "icon": CardMembershipRoundedIcon,
        "prefix": "ISO 45001",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 0,
        "label": "Emissions Reduction targets",
        "icon": TrackChangesRoundedIcon,
        "prefix": "SBTi Validated",
        "isdecimal": false,
        "suffix": ""
    },
]


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));



const Sectionb = () => {

    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };

    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };

    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };

    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true);
        setExpanded1(true);
        setExpanded3(true);
        setExpanded4(true);
        setExpanded5(true);
    };
    const closeAll = () => {
        setExpand(false);
        setExpanded1(false);
        setExpanded3(false);
        setExpanded4(false);
        setExpanded5(false);
    };


    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectiona'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc1'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '160px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box p={5} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Management and Process Disclosures
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Policy and Management Processes
                    </Typography>
                </Box>
                <Box sx={{
                    display: { xs: 'none', md: 'flex' },
                    backgroundImage: `url(${secB})`,
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '250px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>
            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            Policy and management processes
                            <ExpandMore
                                expand={expanded1}
                                onClick={handleExpandClick1}
                                aria-expanded={expanded1}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: { xs: 1000, md: 650 } }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"></TableCell>
                                        <TableCell sx={{ width: '240px' }} align="center"><strong>Disclosure Questions</strong></TableCell>
                                        <TableCell align="center"><strong>P1</strong></TableCell>
                                        <TableCell align="center"><strong>P2</strong></TableCell>
                                        <TableCell align="center"><strong>P3</strong></TableCell>
                                        <TableCell align="center"><strong>P4</strong></TableCell>
                                        <TableCell align="center"><strong>P5</strong></TableCell>
                                        <TableCell align="center"><strong>P6</strong></TableCell>
                                        <TableCell align="center"><strong>P7</strong></TableCell>
                                        <TableCell align="center"><strong>P8</strong></TableCell>
                                        <TableCell align="center"><strong>P9</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ backgroundColor: "#e6e7e8" }} component="th" scope="row" align='left' colSpan={11}><strong>Policy and Management Processes</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell rowSpan={3} align='center'><b>1</b></TableCell>
                                        <TableCell align='left'>a. Whether your entity's policy/ policies cover each principle and its core elements of the NGRBCs. (Yes/ No)</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>b. Has the policy been approved by the Board? (Yes/ No)</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align='left'>c. Web Link of the Policies, if available</TableCell>
                                        <TableCell colSpan={9}>
                                            It has been the Company's practice to upload all policies on the intranet site for the information and implementation by the internal stakeholders. <br />
                                            Policies viz. Code of Conduct for Directors, Code of Conduct for Employees, Anti-Bribery and Anti-Corruption Policy, Policy on Prevention of Sexual Harassment and Corporate Social Responsibility Policy are available on the following web-link: <a href="https://www.mahindra.com/investor-relations/policies-and-documents" target="_blank" rel="noopener noreferrer">https://www.mahindra.com/investor-relations/policies-and-documents</a>
                                            <br /><br />
                                            Refer policy mapping below
                                            <br /><br />
                                            <strong>P1</strong>: Anti-Corruption &amp; Anti Bribery Policy, Code of Conduct of Directors, Materiality Policy
                                            <br />
                                            <strong>P2</strong>: Suppliers Code Of Conduct, Environment Policy, Supplier Code of Conduct
                                            <br />
                                            <strong>P3</strong>: Safety Policy, Human Rights Policy, Related Party Transaction Policy
                                            <br />
                                            <strong>P4</strong>: Corporate Social Responsibility Policy, Supplier Code of Conduct, Whistle Blower Policy
                                            <br />
                                            <strong>P5</strong>: Human Rights Policy, Code of Conduct for Employees, Policy for Remuneration
                                            <br />
                                            <strong>P6</strong>: Environment Policy, Biodiversity Policy, Zero Waste to landfill, Water Policy
                                            <br />
                                            <strong>P7</strong>: Code Of Conduct &amp; Ethics, Suppliers Code of Conduct, Code Highlights for Business Partners
                                            <br />
                                            <strong>P8</strong>: Corporate Social Responsibility Policy, Privacy Policy, Policy on Prevention of Sexual Harassment, Investor Grievance Redressal Policy, Supplier Code of Conduct
                                            <br />
                                            <strong>P9</strong>: Code Of Conduct &amp; Ethics, Policy on Appointment of Board of Directors, Policy on Advertising and Marketing, Code of Fair Disclosure of UPSI, Information Security Management System Policy, Tax Policy, Conflict Mineral Policy
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell><b>2</b></TableCell>
                                        <TableCell align='left'>Whether the entity has translated the policy into procedures. (Yes/ No)</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell><b>3</b></TableCell>
                                        <TableCell align='left'>Do the enlisted policies extend to your value chain partners? (Yes/ No)</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>No</TableCell>
                                        <TableCell>Yes</TableCell>
                                        <TableCell>No</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell><b>4</b></TableCell>
                                        <TableCell align='left'>Name of the national and international codes/ certifications/ labels/ standards (e.g., Forest Stewardship Council, Fairtrade, Rainforest Alliance, Trustee) standards (e.g., SA 8000, OHSAS, ISO, BIS) adopted by your entity and mapped to each principle.</TableCell>
                                        <TableCell colSpan={9}>
                                            <ol>
                                                <li>ISO 14001</li>
                                                <li>ISO 45001</li>
                                                <li>ISO 9001 (QMS)</li>
                                                <li>ISO 27001</li>
                                                <li>ISO 50001 (EnMS)</li>
                                                <li>GRI Standards</li>
                                                <li>United Nations Global Compact ('UNGC')</li>
                                                <li>Sustainable Development Goals ('SDGs')</li>
                                                <li>Carbon Disclosure Project (CDP) on Climate Change &amp; water</li>
                                                <li>S&amp;P Global Corporate Sustainability Assessment (CSA)</li>
                                                <li>Science Based Targets initiative (SBTi)</li>
                                                <li>Task Force on Climate-related Financial Disclosures (TCFD)</li>
                                                <li>WEF's Stakeholder Capitalism Metrics</li>
                                                <li>European Union's ELV Directive </li>
                                            </ol>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell><b>5</b></TableCell>
                                        <TableCell align='left'>Specific commitments, goals and targets set by the entity with defined timelines, if any.</TableCell>
                                        <TableCell colSpan={9}>
                                            The Company has set internal goals and targets on each of the principles with a few listed below.<br /><br />
                                            <strong>P1</strong>: Maintaining Gold Standard in governance compliance &amp; disclosures and Commitment to abide by Code of Conduct &amp; Ethics.<br /><br />
                                            <strong>P5</strong>: The Company has a formal policy on Human Rights which is available in the public domain, and the Company stands committed to the same.<br /><br />
                                            <strong>P6</strong>: The Company is committed to becoming a Planet Positive business with a clear action plan that includes becoming Carbon Neutral (Scope 1 and 2) by 2040, doubling energy productivity by 2030, zero waste to landfill by 2030, sustaining its water positivity index and increasing its share of renewable energy to 100% by 2030.
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell><b>6</b></TableCell>
                                        <TableCell align='left'>Performance of the entity against the specific commitments, goals and targets along-with reasons in case the same are not met.</TableCell>
                                        <TableCell colSpan={9}>The Company has a clear roadmap on material ESG aspects and planet positive commitments. The detailed performance against roadmap/Action plan is provided in the Sustainability Report.<br />
                                            • 57% emissions reduction from Auto sector and 39% from Farm sector from Base year FY 2018-19. SBTi carbon neutrality commitment achieved in auto sector<br />
                                            • Energy productivity for FY 2025-26 is 122.9% for Auto division and Farm Division 117.66%<br />
                                            • ~37% Renewable Energy share achieved in FY 2025-26<br />
                                            • 83% (19/23) of sites are ZWL certified<br />
                                            • 90.1% of waste generated recovered through recycling, reusing or other recovery options<br />
                                            • Water positivity sustained in FY 2025-26 (100.001%)</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ backgroundColor: "#e6e7e8" }} component="th" scope="row" align='left' colSpan={11}><strong>Governance, Leadership and Oversight</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell><b>7</b></TableCell>
                                        <TableCell align='left'>Statement by director responsible for the business responsibility report, highlighting ESG related challenges, targets and achievements</TableCell>
                                        <TableCell colSpan={9}>
                                            Sustainability &amp; climate action are central to Mahindra Group's long-term vision, and our endeavour is to embed them into core business strategy. We believe that progress must be accompanied by environmental responsibility and societal well-being. Our ESG commitments are rooted in 3 pillars being planet positive (Environment), people positive (Social), and trust positive (Governance). Guided by 'Planet Positive' strategy, Mahindra businesses are progressing to reduce our operational environmental impact, decarbonizing the industries we operate in, focusing on climate adaptation &amp; just transition, and advancing our ESG leadership and climate advocacy actions. During the year, we made progress in energy transition by accelerating energy efficiency measures, renewable energy adoption, and electrification. Beyond emissions, we advanced our work on water positivity, waste management, and material circularity. On the Social front, our commitment is anchored in our core philosophy of "Rise," driving positive change for our employees, partners, and communities. We are actively shaping a future-ready, diverse, and inclusive workforce and investing in upskilling programs to prepare our people for the electric vehicle transition. We continue to invest in safety in operations &amp; supply chain particularly in fire safety. Through our "Rise for Good" initiatives, we continue to empower rural communities, foster girl-child education (through our flagship CSR programs namely Nanhi Kali and Kaabil), and ensure an equitable, just transition for our entire ecosystem as we move toward cleaner mobility solutions. On governance, our framework is anchored on the pillars of integrity, transparency, responsibility, and accountability. Through rigorous ESG disclosures, ethical supply chain practices, responsible board oversight, and stakeholder engagement, we are moving forward.
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell><b>8</b></TableCell>
                                        <TableCell align='left'>Details of the highest authority responsible for implementation and oversight of the Business Responsibility policy (ies).</TableCell>
                                        <TableCell colSpan={9}>
                                            Dr. Anish Shah - Group CEO and Managing Director (DIN: 02719429) is the Director responsible for implementation and oversight of the Business Responsibility Policy(ies).
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell><b>9</b></TableCell>
                                        <TableCell align='left'>Does the entity have a specified Committee of the Board/ Director responsible for decision making on sustainability related issues? (Yes/ No). If yes, provide details.</TableCell>
                                        <TableCell colSpan={9}>
                                            Yes. The Company has a CSR Committee of the Board which oversees corporate social responsibility projects &amp; spend as well as sustainability performance of the Company. It currently comprises of 4 members including Non-executive and Non-independent Director, Independent Directors, and Group CEO &amp; Managing Director. The details of the composition of the CSR Committee are provided in the Corporate Governance Report forming part of the Annual Report.
                                            <br /><br />
                                            The CSR Committee of the Board assesses the BRSR performance twice a year. Other supporting councils or cells are Group Sustainability Council, Group CSR Council, Central Safety Council and Corporate Governance Council, who meet every 3 months for decision making related to sustainability issues.
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            10. Details of Review of NGRBCs by the Company: Indicate whether review was undertaken by Director/ Committee of the Board/ Any other Committee
                            <ExpandMore
                                expand={expanded3}
                                onClick={handleExpandClick3}
                                aria-expanded={expanded3}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded3} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: { xs: 1200, md: 650 } }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong>Subject for review</strong></TableCell>
                                        <TableCell align="center" colSpan={9}><strong>Indicate whether the review was undertaken by the Director/ committee of the Board/ any other committee</strong></TableCell>
                                        <TableCell align="center" colSpan={9}><strong>Frequency (annually/ half yearly/ quarterly/ other - please specify)</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>P1</strong></TableCell>
                                        <TableCell align="center"><strong>P2</strong></TableCell>
                                        <TableCell align="center"><strong>P3</strong></TableCell>
                                        <TableCell align="center"><strong>P4</strong></TableCell>
                                        <TableCell align="center"><strong>P5</strong></TableCell>
                                        <TableCell align="center"><strong>P6</strong></TableCell>
                                        <TableCell align="center"><strong>P7</strong></TableCell>
                                        <TableCell align="center"><strong>P8</strong></TableCell>
                                        <TableCell align="center"><strong>P9</strong></TableCell>
                                        <TableCell align="center"><strong>P1</strong></TableCell>
                                        <TableCell align="center"><strong>P2</strong></TableCell>
                                        <TableCell align="center"><strong>P3</strong></TableCell>
                                        <TableCell align="center"><strong>P4</strong></TableCell>
                                        <TableCell align="center"><strong>P5</strong></TableCell>
                                        <TableCell align="center"><strong>P6</strong></TableCell>
                                        <TableCell align="center"><strong>P7</strong></TableCell>
                                        <TableCell align="center"><strong>P8</strong></TableCell>
                                        <TableCell align="center"><strong>P9</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Performance against above policies and follow up action</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell colSpan={9} align='center'>Half Yearly</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Compliance with statutory requirements of relevance to the principles, and rectification of any non - compliances</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell align="center">Yes</TableCell>
                                        <TableCell colSpan={9} align='center'>Quarterly</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            11. Has the entity carried out independent assessment/ evaluation of the working of its policies by an external agency? (Yes/ No). If yes, provide name of the agency.
                            <ExpandMore
                                expand={expanded4}
                                onClick={handleExpandClick4}
                                aria-expanded={expanded4}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded4} timeout="auto" unmountOnExit>
                    <Box mb={4}>
                        <Typography variant='body1'>
                            Yes, The Company maintains an independent and comprehensive internal audit
                            mechanism encompassing all organisational processes, functions, and critical policies.
                            This is complemented by periodic external assessments conducted across relevant
                            areas, including environment, safety, human rights, and governance, as applicable.
                            <br />
                            As part of the assurance framework for the BRSR and Sustainability Report, the
                            company's policies, processes, and SOPs are reviewed by DNV Business Assurance
                            India Private Limited.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            12. If all Principles are not covered by a policy, reasons to be stated.
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: { xs: 1200, md: 650 } }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Questions</strong></TableCell>
                                        <TableCell align="center"><strong>P1</strong></TableCell>
                                        <TableCell align="center"><strong>P2</strong></TableCell>
                                        <TableCell align="center"><strong>P3</strong></TableCell>
                                        <TableCell align="center"><strong>P4</strong></TableCell>
                                        <TableCell align="center"><strong>P5</strong></TableCell>
                                        <TableCell align="center"><strong>P6</strong></TableCell>
                                        <TableCell align="center"><strong>P7</strong></TableCell>
                                        <TableCell align="center"><strong>P8</strong></TableCell>
                                        <TableCell align="center"><strong>P9</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">The entity does not consider the Principles material to its business (Yes/ No)</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>No</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">The entity is not at a stage where it is in a position to formulate and implement the policies on specified principles (Yes/ No)</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>No</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">The entity does not have the financial or/ human and technical resources available for the task (Yes/ No)</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">It is planned to be done in the next financial year (Yes/ No) </TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Any other reason (please specify)</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
        </Container>
    )
}


export default Sectionb;